<template>
    <ion-page>
        <ion-loading :is-open="busy" message="Loading, please wait"/>
        <standard-header title="Returns Processing" align="middle"/>
        <ion-content>
            <pull-down-refresh :callback="refresh" />
            <ion-list>
                <ion-item lines="none">
                    <ion-label class="ion-text-wrap" v-if="hasScannedItem">
                        <h2>{{ scannedItem.name }}</h2>
                        <p>{{ scannedItem.item_number }}</p>
                    </ion-label>
                    <ion-label v-else>
                        <h2>Scan or search for item</h2>
                    </ion-label>
                    <ion-button size="medium" color="primary" @click="openItemScanner()">
                        <ion-icon slot="icon-only" :icon="barcode"/>
                    </ion-button>
                    <ion-button expand="block" color="primary" size="medium" @click="openItemPicker()">
                        <ion-icon slot="icon-only" :icon="search"/>
                    </ion-button>
                </ion-item>
                <div class="ion-padding-horizontal">
                    <ion-button v-if="hasScannedItem" expand="block" fill="outline" color="dark" @click="$refs['product'].open()">Product Card</ion-button>
                    <product-card-modal ref="product" :item="scannedItem" />
                </div>
            </ion-list>
            <ion-list>
                <ion-item>
                    <ion-label>
                        Returns
                    </ion-label>
                    <ion-select v-model="returnTypeFilter" @ionChange="refresh()">
                        <ion-select-option value="customer">Customer</ion-select-option>
                        <ion-select-option value="amazon">Amazon</ion-select-option>
                    </ion-select>
                </ion-item>
                <ion-item lines="none" v-for="item in returns" :key="item.id" button detail @click="open(item)">
                    <ion-avatar slot="start" class="ion-justify-content-center ion-align-items-center">
                        {{ item.qty_left_to_process }}
                    </ion-avatar>
                    <ion-label class="ion-text-wrap">
                        <h2>
                            {{ item.item.item_number }}
                        </h2>
                        <p v-if="item.is_amazon">
                            Amazon: {{ item.source.removal_order_id.toUpperCase() }}
                        </p>
                        <p v-else-if="item.reason">
                            {{ item.reason }}
                        </p>
                        <p v-else>Customer Return (unknown)</p>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-page>

</template>

<script>
import StandardHeader from "@/components/StandardHeader";
import Process from './Process';
import {
    IonButton,
    IonContent, IonIcon,
    IonAvatar,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonLoading,
    alertController, modalController,
    IonSelect,
    IonSelectOption
} from "@ionic/vue";
import _ from 'lodash';
import {checkmarkCircle, search, barcode, listOutline} from 'ionicons/icons';
import {Capacitor} from "@capacitor/core";
import ItemSearchModalHelper from "@/services/ItemSearchModalHelper";
import ProductCardModal from "@/components/Modals/ProductCardModal";
import PullDownRefresh from "@/components/PullDownRefresh";
export default {
    name: "List",
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    components: {
        PullDownRefresh,
        ProductCardModal,
        StandardHeader,
        IonLoading,
        IonContent, IonItem, IonLabel, IonList, IonPage, IonIcon, IonButton, IonAvatar,
        IonSelect,
        IonSelectOption
    },
    props: {
        type: String
    },
    computed: {
        title() {
            return this.type + ' Items';
        },
        locations() {
            return this.hasScannedItem?this.scannedItem.locations:[];
        },
        include() {
            return 'skus,locations,locations.pivot,image_urls'
        },
        hasSelectedLocation() {
            return this.location && this.location.id > 0;
        },
        hasScannedItem() {
            return this.scannedItem && this.scannedItem.id > 0;
        }
    },
    mounted() {
        this.refresh();
    },
    methods: {
        async refresh(event) {
            await this.$nextTick();
            const payload = {
                include: 'item,source',
                status: 'incomplete_only',
                per_page: 999,
                type: this.returnTypeFilter
            };

            if (this.scannedItem) {
                payload.item_id = this.scannedItem.id;
            }

            this.$http
                .get('/api/returns', {
                    params: payload
                })
                .then(response => {
                    this.returns = response.data.items;
                }).catch(error => {
                    this.$validationAlert(error);
                    this.returns = [];
                }).finally(() => {
                    if (event && event.target && event.target.complete) {
                        event.target.complete();
                    }
                });
        },
        open(itemReturn) {
            modalController.create({
                component: Process,
                componentProps: {
                    itemReturn: itemReturn
                }
            }).then(m => {
                m.present();
                m.onDidDismiss().then(() => {
                    this.refresh();
                });
            });
        },
        async openItemScanner() {
            if (Capacitor.platform === 'web') {
                const alert = await alertController.create({
                    header: 'Enter Item #ID',
                    inputs: [{
                        type: 'number',
                        name: 'item_id'
                    }],
                    buttons: ['Ok']
                });
                alert.onDidDismiss().then(input => {
                    const id = input.data.values.item_id;
                    this.$http.get(`/api/items/${id}`)
                        .then(response => {
                            this.scannedItem = response.data;
                            this.refresh();
                        });
                });
                alert.present();
                return;
            }
            this.$scanner.search().then(result => {
                this.scannedItem = result;
                this.refresh();
            }).catch(error => {
                this.scannedItem = {};
                this.$toast.danger(error);
            });
        },
        openItemPicker() {
            ItemSearchModalHelper.open(this.include).then(item => {
                if (! (item.data && item.data.id)) {
                    return;
                }
                this.scannedItem = item.data;
                this.refresh();
            });
        }
    },
    data() {
        return {
            returnTypeFilter: 'customer',
            busy: false,
            returns: [],
            location: {},
            scannedItem: {}
        }
    },
    setup() {
        return {
            checkmarkCircle, search, barcode, listOutline
        }
    }

}
</script>
<style scoped>
ion-badge {
    vertical-align: bottom;
}
ion-avatar {
    border-radius: 50%;
    background-color: var(--ion-color-primary);
    color: var(--ion-color-primary-contrast);
    font-weight: bold;
    display:flex;
}
</style>
